import Sidebar from '@components/aria/Sidebar/Sidebar';
import WithCurrentUser from '@services/WithCurrentUser';

const UnauthorizedPage = () => {
  return (
    <WithCurrentUser>
      <Sidebar>
        <div style={{ padding: '50px' }}>
          <h1>Unauthorized Access</h1>
          <p>You do not have permission to view this page.</p>
        </div>
      </Sidebar>
    </WithCurrentUser>
  );
};

export default UnauthorizedPage;
